import axios from './axios';

export default class GradedItem {
  static getGradedItems(cohortId, bootcampId, studentId) {
    const params = { cohort_id: cohortId, bootcamp_id: bootcampId, student_id: studentId };
    return axios.get('/assessments/graded_items', { params: params }).then(response => response.data);
  }
}
